import { getDatabase, ref, push, set } from 'firebase/database';

// Browser-compatible logger
class Logger {
  constructor() {
    this.isDevelopment = process.env.NODE_ENV === 'development';
    this.db = getDatabase();
  }

  formatMessage(level, message, meta = {}) {
    const timestamp = new Date().toISOString();
    return {
      timestamp,
      level,
      message,
      ...meta,
      userAgent: navigator.userAgent,
      url: window.location.href,
      path: window.location.pathname
    };
  }

  async storeLog(formattedMessage) {
    try {
      const logsRef = ref(this.db, 'logs');
      const newLogRef = push(logsRef);
      await set(newLogRef, {
        ...formattedMessage,
        timestamp: Date.now()
      });
    } catch (error) {
    }
  }

  async log(level, message, meta = {}) {
    const formattedMessage = this.formatMessage(level, message, meta);
    
    // Store logs in Firebase Realtime Database
    await this.storeLog(formattedMessage);
  }

  async info(message, meta = {}) {
    await this.log('info', message, meta);
  }

  async error(message, meta = {}) {
    await this.log('error', message, meta);
  }

  async warn(message, meta = {}) {
    await this.log('warn', message, meta);
  }

  async debug(message, meta = {}) {
    if (this.isDevelopment) {
      await this.log('debug', message, meta);
    }
  }
}

export const logger = new Logger(); 